import { v4 as uuidv4 } from 'uuid';
import store from '../store';
import { config } from '../config';
import { PaylinkFormRow } from '../types/paylink/PaylinkFormRow';
import { ParsedPaylinkItem } from '../types/paylink/ParsedPaylinkItem';
import { ParsedCustomerInfo } from '../types/paylink/ParsedCustomerInfo';

export interface AiParseResult {
    rows: PaylinkFormRow[];
    customer?: ParsedCustomerInfo;
}

export const parseContentForPaylink = async (
    text?: string,
    files?: File[]
): Promise<AiParseResult> => {
    const formData = new FormData();

    if (text) {
        formData.append('text', text);
    }

    if (files) {
        for (const file of files) {
            formData.append('files', file);
        }
    }

    const { token } = store.getState().session;

    const response = await fetch(`${config.ApiHost}/ai/parse`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: formData,
    });

    if (!response.ok) {
        const errorBody = await response.json().catch(() => null);
        throw new Error(errorBody?.error ?? `AI parsing failed (${response.status})`);
    }

    const body: { items: ParsedPaylinkItem[]; customer?: ParsedCustomerInfo } =
        await response.json();

    const rows = body.items.map(item => ({
        rowId: uuidv4(),
        articleNumber: item.articleNumber,
        description: item.description,
        unitPrice: item.unitPrice,
        quantity: item.quantity,
        vatRate: item.vatRate,
    }));

    return { rows, customer: body.customer ?? undefined };
};
